module.exports = __webpack_public_path__ + "static/intrest-free-payment-325b85230a2a64e02fd881387c0d4449.webp";